export const bookData = {
  title: "KETURI VARTAI Į SAVE",
  subtitle: "Kaip gyventi pagal savo žvaigždes. Žingsnis po žingsnio",
  price: 14.9,
  currency: "€",
  coverImage: "https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/1758d4b0fd0095db3f51d40767c6a2b8.png",
  logoImage: "https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/d4ec553dfab1e13661941b103948c86a.png",
  pages: 99,
  chapters: 4,
  exercises: 15,
  rating: 4.9,
  readers: 2847,
  recommendationRate: 98
};

export const features = [
  {
    icon: "ri-rocket-line",
    title: "Greito Starto Puslapis",
    description: "Kad iš karto žinotum, kaip naudotis knyga ir pradėti savo kelionę be jokių klausimų ar abejonių."
  },
  {
    icon: "ri-scales-line",
    title: "Elementų Balanso Diagnostika",
    description: "Sužinok, kurių energijų tau per daug, o kurių trūksta – ir gauk konkrečius sprendimus, kaip atkurti pusiausvyrą."
  },
  {
    icon: "ri-compass-3-line",
    title: "4 Elementų Kelionė",
    description: "Giliai pasinerk į kiekvieną elementą – Ugnį, Orą, Vandenį ir Žemę – su praktinėmis įžvalgomis ir pratimais."
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Praktikos ir Mini Ritualai",
    description: "Paprasti 5–10 minučių pratimai, kuriuos gali atlikti bet kada, bet kur – be jokių sudėtingų įrankių."
  },
  {
    icon: "ri-map-2-line",
    title: "Tavo Sielos Žemėlapis",
    description: "Žingsnis po žingsnio vadovas, kaip sukurti savo unikalų sielos žemėlapį ir jį interpretuoti."
  },
  {
    icon: "ri-gift-line",
    title: "Užbaigimo Ritualas. Sielos Pažadai",
    description: "Galinga baigiamoji ceremonija, kuri padeda įtvirtinti pokyčius ir duoti sau svarbius pažadus ateičiai."
  }
];

export const journeySteps = [
  {
    number: 1,
    title: "Greito Starto Puslapis",
    description: "Kad iš karto žinotum, kaip naudotis knyga ir pradėti savo kelionę be jokių klausimų ar abejonių."
  },
  {
    number: 2,
    title: "Elementų Balanso Diagnostika",
    description: "Sužinok, kurių energijų tau per daug, o kurių trūksta – ir gauk konkrečius sprendimus, kaip atkurti pusiausvyrą."
  },
  {
    number: 3,
    title: "4 Elementų Kelionė",
    description: "Giliai pasinerk į kiekvieną elementą – Ugnį, Orą, Vandenį ir Žemę – su praktinėmis įžvalgomis ir pratimais."
  },
  {
    number: 4,
    title: "Praktikos ir Mini Ritualai",
    description: "Paprasti 5–10 minučių pratimai, kuriuos gali atlikti bet kada, bet kur – be jokių sudėtingų įrankių."
  },
  {
    number: 5,
    title: "Tavo Sielos Žemėlapis",
    description: "Žingsnis po žingsnio vadovas, kaip sukurti savo unikalų sielos žemėlapį ir jį interpretuoti."
  },
  {
    number: 6,
    title: "Užbaigimo Ritualas. Sielos Pažadai",
    description: "Galinga baigiamoji ceremonija, kuri padeda įtvirtinti pokyčius ir duoti sau svarbius pažadus ateičiai."
  }
];

export const testimonials = [
  {
    name: "Rasa",
    city: "Vilnius",
    rating: 5,
    text: "Perskaitžiau per savaitgalį. Labai įdomu buvo sužinoti apie savo elementus. Dabar suprantu, kodėl kartais taip sunku susikalbėti su vyru 😄"
  },
  {
    name: "Mindaugas",
    city: "Kaunas",
    rating: 5,
    text: "Nežinojau, kad astrologijoj gali būt tiek daug prasmės. Pratimai paprasti, bet tikrai veikia. Ačiū už knygą!"
  },
  {
    name: "Greta",
    city: "Klaipėda",
    rating: 5,
    text: "Pati geriausia, kad nereikia nieko sudėtingo. Viską galima daryti namuose. Jau trečią kartą skaitau ir vis atrandu kažką naujo"
  },
  {
    name: "Tomas",
    city: "Šiauliai",
    rating: 5,
    text: "Skeptiškai žiūrėjau į tokius dalykus, bet ši knyga tikrai kitokia. Daug praktikos, mažai vandens. Rekomenduoju"
  },
  {
    name: "Ieva",
    city: "Panevėžys",
    rating: 4,
    text: "Labai patiko skyrius apie santykius. Dabar geriau suprantu ne tik save, bet ir savo artimuosius. Verta kiekvieno euro"
  },
  {
    name: "Darius",
    city: "Alytus",
    rating: 5,
    text: "Nustebau, kaip tiksliai aprašyta mano situacija. Pratimai padėjo susitvarkyti su mintimis. Dėkui už tokį darbą!"
  }
];

export const stats = [
  { value: "MOBILUS", label: "Optimizuota telefono skaitymui" },
  { value: "PRADEDANTIEMS", label: "Aiškiai nuo pirmo puslapio" },
  { value: "AKIMIRKSNIU", label: "PDF iš karto po apmokėjimo" },
  { value: "PRAKTIKOS", label: "5–10 min per dieną" }
];

export const trustBadges = [
  { icon: "ri-lock-line", text: "Saugus mokėjimas" },
  { icon: "ri-flashlight-line", text: "Akimirksnis pristatymas" }
];
